import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

import { DisclosureApplication } from '../../models/disclosure-type.model';

export interface DisclosureApplicationState extends EntityState<DisclosureApplication, number> {
  applicationID: number;
}

function createInitialState(): DisclosureApplication {
  return <DisclosureApplication>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'disclosure-application-store', idKey: 'applicationID' })
export class DisclosureApplicationStore extends EntityStore<DisclosureApplicationState> {
  constructor() {
    super(createInitialState());
  }
}
